export enum TimeFormat {
  HHMM = 'hhmm',
  HH_MM = 'hh:mm',
}
